/**
 * @GENERATED from Figma node 693:15946
 */

import * as React from "react";
export type IconProps = Omit<React.SVGProps<SVGSVGElement>, "color">;
const GoogleFilesBright = (props: IconProps, ref: React.Ref<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    focusable={false}
    role="presentation"
    ref={ref}
    {...props}
  >
    <path
      fill="#34A853"
      d="M10.175 5.8H3.37c-.754 0-1.368.604-1.368 1.346v6.985c0-.18.066-.35.195-.476z"
    />
    <path
      fill="#4285F4"
      d="M20.632 19.455H3.37c-.754 0-1.367-.597-1.367-1.33V13.98c0-.178.065-.345.194-.47l9.605-9.32a.68.68 0 0 1 .507-.188h8.324c.754 0 1.367.597 1.367 1.33v12.816c-.012.721-.615 1.308-1.368 1.308"
    />
    <path
      fill="#EA4335"
      d="m11.8 4.21-9.605 9.446a.62.62 0 0 0-.194.476v.054c0-.18.151-.33.334-.34h8.291c.755 0 1.368-.604 1.368-1.345V4.339c0-.191.15-.339.344-.339h-.032a.77.77 0 0 0-.505.21"
    />
    <path
      fill="#FBBC04"
      d="M2.001 14.186c0-.265.172-.498.431-.583l6.063-1.897a2.07 2.07 0 0 0 1.324-1.304l1.928-5.958a.62.62 0 0 1 .592-.424h-.032a.72.72 0 0 0-.484.191l-9.628 9.445a.62.62 0 0 0-.194.477z"
    />
  </svg>
);
const ForwardRef = React.forwardRef(GoogleFilesBright);
export { ForwardRef as GoogleFilesBright };
